<template>
  <div class="printListGroup">
    <div class="bg" v-for="(item, index) in grouplist" :key="item.id+'-'+item.colorIdx">
      <img src="@/assets/delete.png" class="delete" @click="del(index)" />
      <print-list
        :index="index"
        :image_url="item.image_url"
        :spec_name="item.spec_name"
        :singlePrice="item.singlePrice"
        :sheets_number="item.sheets_number"
        :printQty="item.printQty"
        @previewImg="previewImg"
        @calcNum="calcNum"
      ></print-list>
    </div>
  </div>
</template>
<script>
import { Toast,MessageBox } from "mint-ui";
import printList from "@/components/printList";
import {mapState,mapMutations} from "vuex";
export default {
  components: { printList },
  name: "printListGroup",
  computed:{
    ...mapState(['grouplist'])
  },
  methods: {
    ...mapMutations(['DELGROUPLIST','SETGROUPLISTNUM']),
    previewImg(bol, url) {
      this.$emit("previewImg", bol, url);
    },
    calcNum(num, index) {
      let { printQty } = this.grouplist[index];
      if (printQty >= 20 && +num > 0) return Toast("不能再多啦！");
      if (printQty <= 1 && +num < 0) return Toast("亲，不能再少啦！");
      this.SETGROUPLISTNUM({index,num:num+printQty})
    },
    del(index){
        MessageBox.confirm('你确认需要删除该规格吗？').then(res=>{
            this.DELGROUPLIST(index)
        }).catch(err=>{
            console.log("取消")
        })
    }
  },
};
</script>
<style scoped>
.printListGroup {
  margin-top: .16rem;
}
.delete {
  width: .14rem;
  height: .14rem;
  padding: .07rem;
  position: absolute;
  right: .15rem;
  top: .17rem;
  box-sizing: content-box;
}
.bg {
  border-radius: .05rem;
  background-color: #f8fafe;
  box-sizing: border-box;
  padding: .14rem .14rem .19rem .2rem;
  margin-top: .08rem;
  position: relative;
}
.printListGroup .bg:first-child {
  margin-top: 0;
}
</style>
